import React from 'react';
import { Route } from '@/navigation/Route';
import { GatewayPaymentScreen } from './screens';

export const GATEWAY_PAYMENTS_ROUTES = {
  itself: '/financial/gateway-payment',
};

export const GatewayPaymentNavigation = (): JSX.Element => (
  <Route
    exact
    path={GATEWAY_PAYMENTS_ROUTES.itself}
    component={GatewayPaymentScreen}
    isPrivateRoute
  />
);
